import React from 'react';
import { MultiSlideCarouselComponent } from "../../../library/cms/content-components";
import EditIcon from "../../../library/cms/edit-icon";
import InfoIcon from "../../../library/cms/info-icon";
import { MediaManagerController } from "../../../library/cms/media-manager";

export class FourImageGridComponent extends MultiSlideCarouselComponent {

    onClick = (file) => {
        let link = file.link;
        if (link) {
            location.href = link;
        }
    }

    render() {
        var component = this.state.component;
        if (!component || !component.content || !component.content.media) return null;
        var items = component.content.media.slice(0, 4);
        var cssClass = this.props.cssClass || '';
        this.updateMediaUrls(this.props.mediaManagerData);
        let gridTitleCss="cms-image-grid-title";
        if(this.props.hideTitles){
            gridTitleCss += " hide";
        }
        return (
            <div className="relative">
                <div className={"cms-image-grid " + cssClass}>
                    {items.map((file, i) => {
                        return (
                            <div className="cms-image-grid-item" key={i} onClick={() => this.onClick(file)}>
                                <div className="cms-image-grid-image">
                                    <img src={file.url} alt={file.title || ''} />
                                </div>
                                <div className={gridTitleCss}>{file.title}</div>
                            </div>
                        );
                    })}
                </div>
                <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active}>
                    <MediaManagerController
                        postUrl='/api/MediaFile'
                        data={this.props.mediaManagerData}
                        ref={(ref) => this.mediaController = ref}
                        onFilesSelected={this.onFilesSelected.bind(this)}
                        onCancel={this.onFilesCancel.bind(this)}
                    />
                </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </div>
        );
    }
}

export class TwoImageGridComponent extends MultiSlideCarouselComponent {

    onClick = (file) => {
        let link = file.link;
        if (link) {
            location.href = link;
        }
    }

    render() {
        var component = this.state.component;
        if (!component || !component.content || !component.content.media) return null;
        var items = component.content.media.slice(0, 2);
        var cssClass = this.props.cssClass || '';
        this.updateMediaUrls(this.props.mediaManagerData);

        return (
            <div className="relative">
                <div className={"cms-image-grid cms-image-grid-2 " + cssClass}>
                    {items.map((file, i) => {
                        return (
                            <div className="cms-image-grid-item" key={i} onClick={() => this.onClick(file)}>
                                <div className="cms-image-grid-image">
                                    <img src={file.url} alt={file.title || ''} />
                                </div>
                                <div className="cms-image-grid-title">{file.title}</div>
                            </div>
                        );
                    })}
                </div>
                <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active}>
                    <MediaManagerController
                        postUrl='/api/MediaFile'
                        data={this.props.mediaManagerData}
                        ref={(ref) => this.mediaController = ref}
                        onFilesSelected={this.onFilesSelected.bind(this)}
                        onCancel={this.onFilesCancel.bind(this)}
                    />
                </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </div>
        );
    }
}

export default { FourImageGridComponent, TwoImageGridComponent }
